import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const codeFieldSection = css`
  margin-bottom: ${size[32]};
`
